var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 214,
    viewBox: "0 0 199 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427320070"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 18",
    cx: 101.5,
    cy: 43.5,
    r: 43.5,
    fill: "current",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 19",
    d: "M199 186.5C199 241.452 149.452 196.5 94.5 196.5C39.5477 196.5 0 241.452 0 186.5C0 131.548 44.5477 87 99.5 87C154.452 87 199 131.548 199 186.5Z",
    fill: "current",
    fillOpacity: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.6714bc1b443d1937f4a4ee9e96d4cfac.svg";
export { ForwardRef as ReactComponent };